import type { useTranslations } from 'next-intl';

type Translate = ReturnType<typeof useTranslations<'auth.verifyEmail'>>;

export function mapVerifyEmailApiError(t: Translate, code: string): string {
  switch (code) {
    case 'invalid_code':
      return t('errors.api.invalid_code');
    case 'already_verified':
      return t('errors.api.already_verified');
    case 'user_not_found':
      return t('errors.api.user_not_found');
    case 'admin_not_allowed':
      return t('errors.api.admin_not_allowed');
    case 'rate_limited':
      return t('errors.api.rate_limited');
    case 'mfa_not_supported':
      return t('errors.api.mfa_not_supported');
    default:
      return t('errors.api.server_error');
  }
}
